document.addEventListener('DOMContentLoaded', async function() {
    console.log('🔄 Gestionnaire de commande: Initialisation...');
    
    // Track when we're making updates to prevent recursion
    let isUpdating = false;
    
    // Create MutationObserver for detecting dynamic content
    const observer = new MutationObserver(function(mutations) {
      // Skip if already updating
      if (isUpdating) {
        return;
      }
      
      let shouldUpdate = false;
      
      // Check if mutations are relevant
      for (const mutation of mutations) {
        // Only process if nodes were added
        if (mutation.addedNodes.length === 0) continue;
        
        // Skip mutations caused by our own buttons
        if (mutation.target.hasAttribute && mutation.target.hasAttribute('data-checkout-button')) {
          continue;
        }
        
        // Check if any of the added nodes are product forms or contain product forms
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          
          // Check if it's a product form
          if (node.matches && (
              node.matches('product-form, .product-form, [data-product-form], [data-type="add-to-cart-form"]') ||
              node.querySelector('product-form, .product-form, [data-product-form], [data-type="add-to-cart-form"]')
            )) {
            shouldUpdate = true;
            console.log('🔄 Gestionnaire de commande: Nouveau formulaire de produit détecté');
            break;
          }
          
          // Check if it's a button
          if (node.matches && (
              node.matches('.quick-add__submit, .product-form__submit') ||
              node.querySelector('.quick-add__submit, .product-form__submit')
            )) {
            shouldUpdate = true;
            console.log('🔄 Gestionnaire de commande: Nouveau bouton d\'ajout au panier détecté');
            break;
          }
        }
        
        if (shouldUpdate) break;
      }
      
      if (shouldUpdate) {
        console.log('🔄 Gestionnaire de commande: Mise à jour suite aux changements DOM');
        // Use setTimeout to allow browser to complete rendering
        setTimeout(updateProductForms, 10);
      }
    });
    
    // Configuration
    const checkouts = {
      single: {
        price: 19.99,
        url: 'https://n3j8kp.mytrackdeal.com/aff_c?offer_id=99256&aff_id=2359'
      },
      pack: {
        price: 19.99,
        url: 'https://n3j8kp.mytrackdeal.com/aff_c?offer_id=99256&aff_id=2359'
      }
    };
    console.log('✅ Gestionnaire de commande: URLs de commande configurées', checkouts);
  
    // Get shop logo from settings
    const getShopLogo = () => {
      // Try various potential sources for the logo
      const logoElement = document.querySelector('.header__heading-logo');
      if (logoElement && logoElement.src) {
        console.log('🏪 Gestionnaire de commande: Logo trouvé dans l\'en-tête');
        return logoElement.src;
      }
      
      // Try to find in meta tags
      const metaLogo = document.querySelector('meta[property="og:image"]');
      if (metaLogo && metaLogo.content) {
        console.log('🏪 Gestionnaire de commande: Logo trouvé dans les méta tags');
        return metaLogo.content;
      }
      
      // Default to empty if not found
      console.log('🏪 Gestionnaire de commande: Logo non trouvé');
      return '';
    };
    
    const shopLogo = getShopLogo();
    console.log('🏪 Gestionnaire de commande: Logo de la boutique:', shopLogo);
    const shopDomain = window.Shopify ? window.Shopify.shop : window.location.hostname;
    console.log('🏪 Gestionnaire de commande: Domaine de la boutique:', shopDomain);
  
    // Prevent cart access and hide cart elements
    const disableCart = (e) => {
      console.log('🛒 Gestionnaire de commande: Accès au panier empêché');
      e.preventDefault();
      return false;
    };
    
    // Hide cart links, forms, and buttons
    const cartElements = document.querySelectorAll('a[href*="/cart"], a[href*="/checkout"], .cart-count-bubble, .header__icon--cart');
    console.log(`🛒 Gestionnaire de commande: ${cartElements.length} éléments de panier à désactiver trouvés`);
    
    cartElements.forEach(link => {
      link.onclick = disableCart;
      link.style.display = 'none';
    });
    
    // Disable cart add forms' default behavior but don't hide them
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        return false;
      });
    });
  
    // Disable dynamic checkout buttons
    const paymentButtons = document.querySelectorAll('.shopify-payment-button');
    console.log(`💳 Gestionnaire de commande: ${paymentButtons.length} boutons de paiement à désactiver trouvés`);
    
    paymentButtons.forEach(button => {
      button.style.display = 'none';
    });
  
    // Get product data if on product page
    let productData = null;
    let currentVariant = null;
  
    if (window.location.pathname.startsWith('/products/')) {
      console.log('🔍 Gestionnaire de commande: Page produit détectée, récupération des données produit');
      try {
        const productPath = window.location.pathname.replace(/\/variant\/[^/]+/, '');
        const jsonUrl = `${productPath}.json`;
        console.log(`🔍 Gestionnaire de commande: Récupération des données produit depuis ${jsonUrl}`);
        
        const response = await fetch(jsonUrl);
        productData = await response.json();
        console.log('✅ Gestionnaire de commande: Données produit chargées', productData);
        
        // Get current variant
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        currentVariant = variantId 
          ? productData.product.variants.find(v => v.id == variantId) 
          : productData.product.variants[0];
        
        console.log('✅ Gestionnaire de commande: Variante actuelle:', currentVariant);
      } catch (error) {
        console.error('❌ Gestionnaire de commande: Échec du chargement des données produit:', error);
      }
    }
  
    // Génère l'URL de checkout pour un produit donné
    function getCheckoutUrl(productInfo) {
      const checkoutType = productInfo.isPack ? checkouts.pack : checkouts.single;
      
      // Generate click ID
      const clickId = `click_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      
      // Build tracking parameters
      const params = new URLSearchParams();
      params.append('aff_sub', shopDomain);           // Shop domain (e.g., "candydreamz.fr")
      params.append('aff_sub2', clickId);             // Generated click ID (e.g., "click_1234567890_abc123")
      params.append('source', `${productInfo.name}___${productInfo.image}`); // Product name + image URL
      
      return `${checkoutType.url}&${params.toString()}`;
    }
  
    // Create checkout button
    function createCheckoutButton(productInfo) {
      console.log('🔘 Gestionnaire de commande: Création du bouton de commande pour', productInfo.name);
      
      const button = document.createElement('a');
      button.id = 'AddToCartBtn';
      button.className = 'button button--primary button--full-width atc-button';
      button.setAttribute('data-checkout-button', 'true'); // Mark as our button
      
      // Build checkout URL with tracking parameters
      const checkoutUrl = getCheckoutUrl(productInfo);
      button.href = checkoutUrl;
      console.log(`🔗 Gestionnaire de commande: URL du bouton générée: ${checkoutUrl}`);
      
      const buttonContent = document.createElement('span');
      buttonContent.className = 'button-content';
      buttonContent.style.display = 'flex';
      buttonContent.style.alignItems = 'center';
      buttonContent.style.justifyContent = 'center';
      buttonContent.style.gap = '1rem';
      
      // Cart icon
      const cartIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      cartIcon.setAttribute("width", "20");
      cartIcon.setAttribute("height", "20");
      cartIcon.setAttribute("viewBox", "0 0 24 24");
      cartIcon.setAttribute("fill", "none");
      cartIcon.setAttribute("stroke", "currentColor");
      cartIcon.setAttribute("stroke-width", "2");
      cartIcon.setAttribute("stroke-linecap", "round");
      cartIcon.setAttribute("stroke-linejoin", "round");
      cartIcon.innerHTML = `
        <path d="M4 7h16l-1.5 9h-13z"/>
        <circle cx="9" cy="19" r="2"/>
        <circle cx="18" cy="19" r="2"/>
        <path d="M4 7l-1-4h-2"/>
      `;
      cartIcon.style.color = "white";
  
      const commandText = document.createElement('span');
      commandText.textContent = 'COMMANDER';
  
      // Pour tous les CTA, juste le texte et l'icône (pas de prix dans le bouton)
      buttonContent.appendChild(cartIcon);
      buttonContent.appendChild(commandText);
      button.appendChild(buttonContent);
  
      // Add click handler for tracking
      button.addEventListener('click', (e) => {
        console.log('🖱️ Gestionnaire de commande: Bouton de commande cliqué pour', productInfo.name);
        
        // Toujours déclencher l'événement TikTok AddToCart
        try {
          console.log('📊 Gestionnaire de commande: Suivi avec TikTok Pixel');
          
          // Préparer les données de l'événement
          const eventData = {
            content_id: productInfo.name,
            content_type: 'product',
            content_name: productInfo.name,
            quantity: 1,
            price: productInfo.isPack ? '19.99' : '19.99',
            value: productInfo.isPack ? 19.99 : 19.99,
            currency: 'EUR'
          };
          
          // Vérifier si ttq est disponible directement
          if (typeof ttq !== 'undefined') {
            console.log('📊 Gestionnaire de commande: ttq disponible, tracking direct');
            ttq.track('AddToCart', eventData);
          } else {
            // Initialiser TikTok Pixel si nécessaire et déclencher l'événement
            console.log('📊 Gestionnaire de commande: Initialisation du pixel TikTok');
            
            window.TiktokAnalyticsObject = 'ttq';
            window.ttq = window.ttq || [];
            
            // Fonction pour déclencher l'événement une fois ttq disponible
            const triggerEvent = function() {
              window.ttq.track('AddToCart', eventData);
              console.log('📊 Gestionnaire de commande: Événement AddToCart déclenché');
            };
            
            // Si TikTok n'est pas encore chargé, le charger
            if (typeof window.ttq.track !== 'function') {
              !function (w, d, t) {
                var ttq = w[t] = w[t] || [];
                ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];
                ttq.setAndDefer = function(t, e) { t[e] = function() { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } };
                for(var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
                ttq.instance = function(t) {
                  for(var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
                  return e
                };
                ttq.load = function(e, n) {
                  var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
                  ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {};
                  var o = document.createElement("script");
                  o.type = "text/javascript", o.async = !0, o.src = i + "?sdkid=" + e + "&lib=" + t;
                  var a = document.getElementsByTagName("script")[0];
                  a.parentNode.insertBefore(o, a);
                  
                  // Déclencher l'événement une fois chargé
                  o.onload = function() {
                    triggerEvent();
                  };
                };
                ttq.load('D0A18EJC77UF1HSAL5P0');
                // Essayer de déclencher l'événement si ttq est déjà initialisé
                setTimeout(function() {
                  if (typeof window.ttq.track === 'function') {
                    triggerEvent();
                  }
                }, 500);
              }(window, document, 'ttq');
            } else {
              // Si TikTok est déjà chargé mais ttq n'est pas une variable globale
              triggerEvent();
            }
          }
          
          // Ajout silencieux au panier pour cohérence des données
          if (productInfo.variantId) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: productInfo.variantId,
                quantity: 1
              })
            }).then(response => {
              console.log('🛒 Gestionnaire de commande: Ajout silencieux au panier réussi', response);
            }).catch(error => {
              console.error('❌ Gestionnaire de commande: Échec de l\'ajout silencieux au panier', error);
            });
          }
        } catch (error) {
          console.error('❌ Gestionnaire de commande: Erreur lors du suivi TikTok', error);
        }
      });
  
      console.log('✅ Gestionnaire de commande: Bouton créé avec succès');
      return button;
    }
  
    // Update product forms - main product page and product cards
    function updateProductForms() {
      // Prevent recursion
      if (isUpdating) {
        console.log('⚠️ Gestionnaire de commande: Déjà en cours de mise à jour, appel ignoré');
        return;
      }
      
      isUpdating = true;
      console.log('🔄 Gestionnaire de commande: Mise à jour des formulaires produit...');
      
      // Temporarily disconnect observer while making changes
      observer.disconnect();
      
      // Handle main product page forms
      const productForms = document.querySelectorAll('product-form, .product-form, [data-product-form], [data-type="add-to-cart-form"]');
      console.log(`🔍 Gestionnaire de commande: ${productForms.length} formulaires produit à mettre à jour trouvés`);
      
      // Check if forms already have our buttons to avoid duplicating
      const formsToUpdate = Array.from(productForms).filter(form => 
        !form.querySelector('[data-checkout-button="true"]')
      );
      
      if (formsToUpdate.length === 0) {
        console.log('ℹ️ Gestionnaire de commande: Tous les formulaires ont déjà des boutons de commande');
        isUpdating = false;
        observer.observe(document.body, { childList: true, subtree: true });
        return;
      }
      
      formsToUpdate.forEach((formContainer, index) => {
        // Check if this is a main product form or a card product form
        const isProductPage = formContainer.classList.contains('main-product-form') || 
                              formContainer.closest('.product__info-container') || 
                              window.location.pathname.startsWith('/products/');
        
        console.log(`🔍 Gestionnaire de commande: Traitement du formulaire ${index + 1}, isProductPage: ${isProductPage}`);
        
        let productInfo;
  
        if (isProductPage && productData) {
          productInfo = {
            name: currentVariant && currentVariant.title !== 'Default Title' 
              ? `${productData.product.title} - ${currentVariant.title}`
              : productData.product.title,
            image: currentVariant?.featured_image?.src || 
                   productData.product.images[0]?.src || 
                   '',
            isPack: document.querySelector('body').classList.contains('template-product-pack'),
            isProductPage: true,
            variantId: currentVariant?.id,
            isMainCta: true // Marqueur pour le bouton principal
          };
          console.log('✅ Gestionnaire de commande: Informations produit créées à partir des données produit', productInfo);
        } else {
          // For product cards
          const card = formContainer.closest('.card');
          if (card) {
            const heading = card.querySelector('.card__heading');
            const image = card.querySelector('.media img');
            const variantInput = card.querySelector('input[name="id"]');
            
            if (heading && image) {
              productInfo = {
                name: heading.textContent.trim(),
                image: image.src,
                isPack: card.classList.contains('product-pack'),
                isProductPage: false,
                variantId: variantInput ? variantInput.value : null,
                isMainCta: false // Les autres CTA
              };
              console.log('✅ Gestionnaire de commande: Informations produit créées à partir de la carte', productInfo);
            } else {
              console.log('❌ Gestionnaire de commande: Éléments d\'information produit manquants dans la carte');
            }
          } else {
            console.log('ℹ️ Gestionnaire de commande: Formulaire non contenu dans une carte, ignoré');
          }
        }
  
        // Only replace if we have product info
        if (productInfo) {
          // Supprimer les anciens boutons de checkout
          formContainer.querySelectorAll('[data-checkout-button="true"]').forEach(btn => btn.remove());
          // Find and remove existing buttons
          const existingButtons = formContainer.querySelectorAll('.product-form__submit, button[name="add"], .shopify-payment-button');
          console.log(`🔍 Gestionnaire de commande: ${existingButtons.length} boutons à masquer dans le formulaire ${index + 1}`);
          
          existingButtons.forEach(button => button.style.display = 'none');
          
          // Create and append checkout button
          const buttonsContainer = formContainer.querySelector('.product-form__buttons') || formContainer;
          console.log(`✅ Gestionnaire de commande: Conteneur de boutons trouvé dans le formulaire ${index + 1}:`, buttonsContainer !== formContainer);
          
          const checkoutButton = createCheckoutButton(productInfo);
          
          if (buttonsContainer !== formContainer) {
            // Clear the buttons container and add our button
            buttonsContainer.innerHTML = '';
            buttonsContainer.appendChild(checkoutButton);
            console.log(`✅ Gestionnaire de commande: Bouton ajouté au conteneur de boutons dans le formulaire ${index + 1}`);
          } else {
            // Just append our button to the form
            formContainer.appendChild(checkoutButton);
            console.log(`✅ Gestionnaire de commande: Bouton ajouté directement au formulaire ${index + 1}`);
          }
        } else {
          console.log(`ℹ️ Gestionnaire de commande: Pas d'informations produit pour le formulaire ${index + 1}, ignoré`);
        }
      });
      
      // Handle quick-add buttons and any other standalone add-to-cart buttons
      const quickAddButtons = document.querySelectorAll('.quick-add__submit, .product-form__submit:not([style*="display: none"])');
      console.log(`🔍 Gestionnaire de commande: ${quickAddButtons.length} boutons d'ajout rapide à mettre à jour trouvés`);
      
      const buttonsToReplace = Array.from(quickAddButtons).filter(button => 
        !button.closest('[data-product-form]') && 
        !button.closest('product-form') &&
        !button.previousElementSibling?.hasAttribute('data-checkout-button') &&
        !button.nextElementSibling?.hasAttribute('data-checkout-button')
      );
      
      buttonsToReplace.forEach((button, index) => {
        console.log(`🔍 Gestionnaire de commande: Traitement du bouton autonome ${index + 1}`);
        
        const card = button.closest('.card');
        if (card) {
          const heading = card.querySelector('.card__heading');
          const image = card.querySelector('.media img');
          const variantInput = card.querySelector('input[name="id"]');
          
          if (heading && image) {
            const productInfo = {
              name: heading.textContent.trim(),
              image: image.src,
              isPack: card.classList.contains('product-pack'),
              isProductPage: false,
              variantId: variantInput ? variantInput.value : null,
              isMainCta: false // Les autres CTA
            };
            
            console.log(`✅ Gestionnaire de commande: Informations produit créées pour le bouton autonome ${index + 1}`, productInfo);
            
            const checkoutButton = createCheckoutButton(productInfo);
            button.style.display = 'none';
            button.parentNode.insertBefore(checkoutButton, button.nextSibling);
            console.log(`✅ Gestionnaire de commande: Bouton ajouté pour le bouton autonome ${index + 1}`);
          } else {
            console.log(`❌ Gestionnaire de commande: Éléments d'information produit manquants pour le bouton autonome ${index + 1}`);
          }
        } else {
          console.log(`ℹ️ Gestionnaire de commande: Bouton autonome ${index + 1} non contenu dans une carte, ignoré`);
        }
      });
      
      // Handle sticky Add to Cart buttons
      const stickyAtcButtons = document.querySelectorAll('[id^="SectionAtcBtn-"], .main-product-atc:not([data-checkout-button="true"])');
      console.log(`🔍 Gestionnaire de commande: ${stickyAtcButtons.length} boutons ATC flottants à mettre à jour trouvés`);
      
      stickyAtcButtons.forEach((button, index) => {
        // Skip if this button has already been processed or is within a form we've already handled
        if (button.style.display === 'none' || 
            button.hasAttribute('data-checkout-button') ||
            button.parentNode.querySelector('[data-checkout-button="true"]')) {
          console.log(`ℹ️ Gestionnaire de commande: Bouton flottant ${index + 1} déjà traité, ignoré`);
          return;
        }
        
        console.log(`🔍 Gestionnaire de commande: Traitement du bouton flottant ${index + 1}`);
        
        // For sticky buttons, use the main product info if available
        if (productData && currentVariant) {
          const productInfo = {
            name: currentVariant && currentVariant.title !== 'Default Title' 
              ? `${productData.product.title} - ${currentVariant.title}`
              : productData.product.title,
            image: currentVariant?.featured_image?.src || 
                   productData.product.images[0]?.src || 
                   '',
            isPack: document.querySelector('body').classList.contains('template-product-pack'),
            isProductPage: true,
            variantId: currentVariant?.id,
            isMainCta: false // Marqueur pour le bouton principal
          };
          
          console.log(`✅ Gestionnaire de commande: Informations produit créées pour le bouton flottant ${index + 1}`, productInfo);
          
          const checkoutButton = createCheckoutButton(productInfo);
          button.style.display = 'none';
          
          // Preserve the button's parent container styling
          const buttonParent = button.parentNode;
          
          // If button has class sticky-atc__button, we need to replace it properly
          if (buttonParent.classList.contains('sticky-atc__button') || 
              buttonParent.classList.contains('sticky-atc') ||
              buttonParent.classList.contains('sticky-add-to-cart')) {
            checkoutButton.className = button.className + ' atc-button'; 
            checkoutButton.id = button.id;
            buttonParent.appendChild(checkoutButton);
          } else {
            button.parentNode.insertBefore(checkoutButton, button.nextSibling);
          }
          
          console.log(`✅ Gestionnaire de commande: Bouton ajouté pour le bouton flottant ${index + 1}`);
        } else {
          console.log(`❌ Gestionnaire de commande: Données produit non disponibles pour le bouton flottant ${index + 1}`);
        }
      });
      
      console.log('✅ Gestionnaire de commande: Mise à jour des formulaires produit terminée');
      isUpdating = false;
      
      // Reconnect observer
      observer.observe(document.body, { childList: true, subtree: true });
    }
  
    // Initialize
    console.log('🔄 Gestionnaire de commande: Exécution de la mise à jour initiale des formulaires');
    updateProductForms();
  
    // Handle variant changes
    document.addEventListener('variant:changed', function(event) {
      console.log('🔄 Gestionnaire de commande: Événement de changement de variante détecté', event.detail.variant);
      if (event.detail && event.detail.variant && productData) {
        const variant = event.detail.variant;
        const variantImage = variant.featured_image?.src || productData.product.images[0]?.src || '';
        // On veut seulement le nom de la variante dans l'URL (sub3)
        const productInfo = {
          name: variant.title, // juste le nom de la variante
          image: variantImage,
          isPack: document.querySelector('body').classList.contains('template-product-pack'),
          isProductPage: true,
          variantId: variant.id,
          isMainCta: true
        };
        const mainCheckoutBtn = document.querySelector('[data-checkout-button="true"]');
        if (mainCheckoutBtn) {
          mainCheckoutBtn.href = getCheckoutUrl(productInfo);
          console.log('✅ Gestionnaire de commande: URL du bouton checkout mise à jour (nom variante)', mainCheckoutBtn.href);
        }
      }
    });
  
    // Add loader styles
    const style = document.createElement('style');
    style.textContent = `
      .loader {
        border: 2px solid #f3f3f3;
        border-top: 2px solid #3498db;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: spin 0.8s linear infinite;
        margin: 0 auto;
      }
  
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      
      .atc-button {
        margin-bottom: 10px;
      }
    `;
    document.head.appendChild(style);
    console.log('✅ Gestionnaire de commande: Styles ajoutés');
    
    // Start observing
    observer.observe(document.body, { childList: true, subtree: true });
    console.log('✅ Gestionnaire de commande: Observateur de mutations démarré');
    
    console.log('✅ Gestionnaire de commande: Initialisation terminée');
  
    let lastVariantId = null;
    setInterval(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      if (variantId && variantId !== lastVariantId && productData) {
        lastVariantId = variantId;
        // Cherche la variante correspondante
        const variant = productData.product.variants.find(v => v.id == variantId);
        if (variant) {
          const variantImage = variant.featured_image?.src || productData.product.images[0]?.src || '';
          // sub3 = nom du produit - nom de la variante
          const productInfo = {
            name: `${productData.product.title} - ${variant.title}`,
            image: variantImage,
            isPack: document.querySelector('body').classList.contains('template-product-pack'),
            isProductPage: true,
            variantId: variant.id,
            isMainCta: true
          };
          const mainCheckoutBtn = document.querySelector('[data-checkout-button="true"]');
          if (mainCheckoutBtn) {
            mainCheckoutBtn.href = getCheckoutUrl(productInfo);
            console.log('✅ Gestionnaire de commande: URL du bouton checkout mise à jour (surveillance URL)', mainCheckoutBtn.href);
          }
        }
      }
    }, 300);
  });